import { Col, Layout, Row } from 'antd'
import { Logo } from '../Logo/Logo'
import { Outlet, useNavigate } from 'react-router-dom'
import { FadeIn } from '../FadeIn'
import { AiOutlineArrowLeft } from 'react-icons/ai'

const { Header: H, Content } = Layout

export const Header = () => {
  const navigate = useNavigate()

  return (
    <FadeIn>
      <>
        <Layout>
          <H
            style={{
              top: 0,
              height: 65,
              zIndex: 1,
              width: '100%',
              backgroundColor: '#f5f5f5',
              paddingTop: 16,
            }}
          >
            <Row justify={'center'} style={{ cursor: 'pointer' }} onClick={() => navigate('/home')}>
              <Col style={{ marginRight: 24 }}>
                <Logo showText={false} height={65} width={65} />
              </Col>
              <Col>
                <Logo showEye={false} height={65} width={65} />
              </Col>
            </Row>
          </H>
        </Layout>
        <Content style={{ padding: '64px 30px' }}>
          <Row align={'middle'} style={{ marginBottom: 24 }}>
            <Col onClick={() => navigate(-1)}>
              <AiOutlineArrowLeft size={36} style={{ cursor: 'pointer' }} />
            </Col>
            <Col onClick={() => navigate(-1)}>
              <span style={{ fontFamily: 'HonestMaria', fontSize: 36, marginLeft: 4 }}>Back</span>
            </Col>
          </Row>
          <Outlet />
        </Content>
      </>
    </FadeIn>
  )
}
